export default {
  computed: {
    monthly() {
      return this.$store.state.master.deliveryPatternMonth.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    },
    dayInMonth() {
      return this.$store.state.master.deliveryPatternMonthDay.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    },
    dayOfWeek() {
      return this.$store.state.master.deliveryPatternDayOfWeek.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    },
    weekNo() {
      return this.$store.state.master.deliveryPatternWeekNo.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    },
    dayDaily() {
      return this.$store.state.master.deliveryPatternDay.map((item) => ({
        value: item.id,
        label: item.name,
      }))
    },
  },
}
